import { render, staticRenderFns } from "./productDelCen.vue?vue&type=template&id=213c1cdc&scoped=true&"
import script from "./productDelCen.vue?vue&type=script&lang=js&"
export * from "./productDelCen.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "213c1cdc",
  null
  
)

export default component.exports